import type { Glyph } from "./types";

export const ArrowDropUpIcon: Glyph = (props) => (
  <svg viewBox="0 0 50 50" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M25.5 9L43.253 39.75L7.746 39.75L25.5 9Z" />
  </svg>
);

export default ArrowDropUpIcon;
